import { animate, group, keyframes, query, style, transition, trigger } from '@angular/animations';

const leaveSelector = ':leave';
const enterSelector = ':enter';
const easeInTiming = '200ms ease-in';
const easeOutTiming = '200ms ease-out';
const easeInOutTiming = '200ms ease-in-out';

export const ViewAnimation = [
  // .job-footer
  trigger('slideBottom', [
    transition(enterSelector, [
      style({ transform: 'translateY(100%)', willChange: 'transform' }),
      animate(easeOutTiming, style({ transform: 'translateY(0%)' })),
    ]),
    transition(leaveSelector, [
      style({ willChange: 'transform' }),
      animate(easeInTiming, style({ transform: 'translateY(100%)' })),
    ]),
  ]),

  trigger('slideInRight', [
    transition(
      '* => apply',
      group([
        query('.pane--left', [
          animate(
            easeInOutTiming,
            keyframes([style({ width: '0', marginRight: '0' }), style({ width: '*', marginRight: '*' })])
          ),
        ]),
        query('.pane--right', [animate(easeInOutTiming, keyframes([style({ width: '100%' }), style({ width: '*' })]))]),
      ])
    ),
  ]),

  trigger('jobEnterLeave', [
    transition(enterSelector, [
      style({ opacity: 0, willChange: 'opacity, transform' }),
      animate(
        '300ms ease-out',
        keyframes([
          style({ opacity: '.25', transform: 'translateY(2rem)' }),
          style({ opacity: '1', transform: 'translateY(0)' }),
        ])
      ),
    ]),
    transition(leaveSelector, [
      style({ opacity: 0, willChange: 'opacity' }),
      animate(easeInTiming, keyframes([style({ opacity: '1' }), style({ opacity: '.25' })])),
    ]),
  ]),

  trigger('skeletonEnter', [
    transition(enterSelector, [
      style({ opacity: 0, maxHeight: '0', overflowY: 'hidden', willChange: 'maxHeight, opacity, overflowY' }),
      animate(
        '300ms 200ms ease-out',
        keyframes([
          style({ maxHeight: 'none', opacity: '0', overflowY: 'visible' }),
          style({ maxHeight: 'none', opacity: '1', overflowY: 'visible' }),
        ])
      ),
    ]),
  ]),
];
